<template>
  <div class="addchannel">
    <div class="addchannel--header">
      <div class="addchannel--header--title">
        <div class="title--cancle" @click="handleToCancelAddChannel($route.params.routerName,$route.params.routeTag)">取消</div>
        <div class="title--text" v-if="addcReadOnly">{{$route.params.routerName?'修改':'新增'}}客户/渠道</div>
        <div class="title--text" v-else>查看客户/渠道</div>
        <div class="title--complete" @click="addcReadOnly && handleToPostAddMarket()">
          <span v-if="addcReadOnly">提交</span>
        </div>
      </div>
      <div class="addchannel--header--text">客户信息</div>
    </div>
    <div class="header-line"></div>
    <div class="addchannel--info">
      <div class="addchannel--info--name">
        <div class="item--name">类型</div>
        <div class="item--address">{{matterTypeValue}}</div>
      </div>
      <div class="addchannel--info--name" :class="{active:checkFieldList.includes('cusName')}">
        <div class="item--name">名称</div>
        <input type="text" :disabled="!addcReadOnly" class="item--ipt" placeholder="请输入渠道名称" v-model="cusName">
      </div>
      <div class="addchannel--info--name" v-if="false" @click="handleToMarketToMap" :class="{active:checkFieldList.includes('address') ||checkFieldList.includes('lng') }">
        <div class="item--name">地址</div>
        <div class="item--address">{{this.$store.state.locationData.address?this.$store.state.locationData.address:'点击获取定位'}}</div>
        <div class="item--icon iconfont">&#xe62b;</div>
      </div>
      <div class="addchannel--info--name">
        <div class="item--name">渠道说明</div>
        <textarea class="item--area" v-if="addcReadOnly" placeholder="请输入渠道说明" rows="3" v-model="remark"></textarea>
        <div class="item--address" v-else>{{remark?remark:'无'}}</div>
      </div>
      <div class="addchannel--info--text" >
        <div>联系人</div>
        <div class="text--item iconfont" @click="handleToAddContract" v-if="addcReadOnly">&#xe602;</div>
      </div>
      <div class="addchannel--info--contract" v-if="mmContactsList.length>0">
        <div
          class="contract--item"
          v-for="(item,index) in mmContactsList"
          :key="(item.contactPhone + index)"
        >
          <div class="item-icon iconfont" @click="handleToDelContract(item.contactPhone)" v-if="addcReadOnly">&#xe638;</div>
          <div class="item--name">{{item.contactName}}</div>
          <div class="item--phone">{{item.contactPhone}}</div>
          <div class="item--job">{{item.post}}</div>
        </div>
      </div>
      <div class="addchannel--info--name" v-if="addcReadOnly">
        <div class="item--name">姓名</div>
        <input type="text" class="item--ipt" placeholder="请输入联系人姓名" v-model="contactName">
      </div>
      <div class="addchannel--info--name" v-if="addcReadOnly">
        <div class="item--name">联系电话</div>
        <input type="text" class="item--ipt" placeholder="请输入联系电话" v-model="contactPhone">
      </div>
      <div class="addchannel--info--name addchannel--info--job" v-if="addcReadOnly">
        <div class="item--name">职务</div>
        <input type="text" class="item--ipt" placeholder="请输入联系人职务" v-model="post">
      </div>
      <div class="addchannel--info--text">
        <div>项目组成员</div>
      </div>
      <div class="addchannel--info--name addchannel--info--person">
        <template v-if="mmFollowStaffList.length > 0">
          <div
            class="person--item"
            v-for="item in mmFollowStaffList"
            :key="item.actorno"
          >{{item.actorname}}</div>
        </template>
        <div class="person--item iconfont" @click="handleToSelectFollowPerson" v-if="addcReadOnly">&#xe602;</div>
      </div>
    </div>
    <div class="addchannel--source" v-if="customFollowFlag">
      <div class="source--title">
        <div class="source--title--cancle" @click="handleToCancleFloat('customFollowFlag')">取消</div>
        <div class="source--title--text">选择项目成员</div>
        <div class="source--title--cancle" @click="handleToCancleFloat('customFollowFlagadd')">完成</div>
      </div>
      <div class="source--item--follow">
        <div
          class="source--item--follow__per"
          :class="{active:mmFollowStaffTag.includes(item.actorno)}"
          v-for="item in customFollowList"
          :key="item.actorno"
          @click="handleToAddFollowPerson(item)"
        >{{item.actorname}}</div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { get, post, postjson } from '../api/api'
import { getFormEmptyField } from '../tools/common'
export default {
  name: 'addchannel',
  data () {
    return {
      id: '', // 新增的是空,更新的是有值
      couldEdit: '', // 控制提交是否显示
      matterType: '1', // 营销类型
      matterTypeValue: '渠道营销', // 营销类型的值，显示使用
      cusName: '', // 客户名称
      remark: '', // 渠道说明
      mmContactsList: [], // 联系人列表
      contactName: '', // 联系人姓名
      contactPhone: '', // 联系人电话
      post: '', // 联系人职务
      customFollowList: [], // 所有成员列表
      customFollowFlag: false, // 控制选择项目组成员列表显示
      mmFollowStaffList: [], // 选中项目组成员列表
      mmFollowStaffTag: [], // 标记是否选中项目组成员
      checkFieldList: [], // 校验表单是否有空
      postFlag: true, // 控制提交一次之后未返回不能再提交
      startTime: '', // 打开该页面记录时间
      addcReadOnly: true
    }
  },
  beforeMount () {
    this.cusName = ''
    this.startTime = new Date().getTime()
    if (this.$route.params.oldMarketData || localStorage.getItem('postData')) {
      const paramsData = this.$route.params.oldMarketData ? this.$route.params.oldMarketData : JSON.parse(localStorage.getItem('postData'))
      this.handleToModifyMarketData(paramsData)
    } else {
      // 添加登陆人到项目成员
      this.handleToItemPerson()
    }
  },
  destroyed () {
    this.$store.commit('delLocationInfo', '')
  },
  methods: {
    // 添加登陆人到项目成员
    handleToItemPerson () {
      this.mmFollowStaffList.push({
        actorname: this.$cookies.get('actorname'),
        actorno: this.$cookies.get('actorno')
      })
      this.mmFollowStaffTag.push(this.$cookies.get('actorno'))
    },
    // 添加联系人信息
    handleToAddContract () {
      const phoneReg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/
      if (!this.contactName || !this.contactPhone) {
        this.$toast.success('联系人信息未填写完整')
        return false
      } else if (!phoneReg.test(this.contactPhone)) {
        this.$toast.success('手机号包含非数字或不足11位')
        return false
      }
      this.mmContactsList.push({
        contactName: this.contactName,
        contactPhone: this.contactPhone,
        post: this.post
      })
      this.contactName = ''
      this.contactPhone = ''
      this.post = ''
    },
    // 删除联系人
    handleToDelContract (phone) {
      this.mmContactsList = this.mmContactsList.filter(item => item.contactPhone !== phone)
    },
    // 选择项目组成员
    async handleToSelectFollowPerson () {
      document.body.style.overflow = 'hidden'
      this.customFollowFlag = true
      const result = await get('/api/CBMS-APP/sUser/listByComBrId', {})
      if (result.success) {
        this.customFollowList = result.data.records
      }
    },
    // 添加项目组成员信息
    handleToAddFollowPerson (itemObj) {
      if (this.mmFollowStaffTag.includes(itemObj.actorno)) {
        this.mmFollowStaffTag.splice(this.mmFollowStaffTag.indexOf(itemObj.actorno), 1)
        this.mmFollowStaffList = this.mmFollowStaffList.filter(item => item.actorno !== itemObj.actorno)
      } else {
        this.mmFollowStaffList.push({
          actorname: itemObj.actorname,
          actorno: itemObj.actorno
        })
        this.mmFollowStaffTag.push(itemObj.actorno)
      }
    },
    // 修改营销事项数据
    async handleToModifyMarketData (marketData) {
      for (const key in marketData) {
        if (key === 'address' || key === 'lng' || key === 'lat') {
          const payLoad = { ...this.$store.state.locationData, [key]: marketData[key] }
          this.$store.commit('setLocationFunc', payLoad)
        } else if (key === 'couldEdit') {
          this.addcReadOnly = marketData[key] && !(this.$route.params.routeTag === 'public' || this.$route.params.routeTag === 'hismarket')
        } else {
          this[key] = marketData[key]
        }
      }
    },
    // 取消添加营销事项
    handleToCancelAddChannel (routerName, routeTag) {
      this.$store.commit('setLocationFunc', '')
      if (routerName) {
        this.$router.push({ name: routerName, params: { id: this.$route.params.id, routeTag } })
      } else {
        this.$router.push('/market')
      }
    },
    // 添加数据提交后端
    async handleToPostAddMarket () {
      if (this.contactName && this.contactPhone) {
        this.mmContactsList.push({
          contactName: this.contactName,
          contactPhone: this.contactPhone,
          post: this.post
        })
        this.contactName = ''
        this.contactPhone = ''
        this.post = ''
      } else if (this.mmContactsList.length === 0 && !this.contactName && !this.contactPhone) {
        this.$toast.success('联系人姓名和电话不能为空')
        return false
      }
      const postData = {
        id: this.id,
        cusName: this.cusName,
        matterType: this.matterType,
        address: this.$store.state.locationData.address ? this.$store.state.locationData.address : '',
        lng: this.$store.state.locationData.lng ? this.$store.state.locationData.lng : '',
        lat: this.$store.state.locationData.lat ? this.$store.state.locationData.lat : '',
        locationDate: this.$store.state.locationData.locationDate ? this.$store.state.locationData.locationDate : '',
        remark: this.remark,
        mmContactsList: this.mmContactsList,
        mmFollowStaffList: this.mmFollowStaffList
      }
      // if (!postData.address) {
      //   this.$toast.success('营销地址未定位')
      //   return false
      // }
      this.checkFieldList = getFormEmptyField(postData)
      if (this.checkFieldList.length === 0 && this.postFlag) {
        this.postFlag = false
        const result = await postjson('/api/CBMS-APP/mmMarketMatter/add', postData)
        if (result.success) {
          this.$toast.success({
            message: '数据添加完成',
            onClose: () => {
              this.postFlag = true
              this.customFollowFlag = false
              this.cusName = ''
              this.remark = ''
              this.mmContactsList = []
              this.contactName = ''
              this.contactPhone = ''
              this.post = ''
              this.checkFieldList = []
              this.mmFollowStaffList = []
              this.mmFollowStaffTag = []
              this.$store.state.locationData = ''
              if (this.$route.params.routerName) {
                this.$router.push({
                  name: this.$route.params.routerName,
                  params: {
                    id: result.data.id,
                    certCode: result.data.certCode,
                    cusName: result.data.cusName
                  }
                })
              } else {
                this.$router.push('market')
              }
            }
          })
        } else {
          this.postFlag = true
          this.$toast.success(`${result.message}`)
        }
      } else {
        this.checkFieldList.forEach(item => {
          if (item === 'mmContactsList') {
            this.$toast.success('联系人未添加')
            return false
          } else if (item === 'mmFollowStaffList') {
            this.$toast.success('项目组成员未添加')
            return false
          } else {
            this.$toast.success('有内容未填写')
            return false
          }
        })
      }
    },
    // 跳转到地图
    handleToMarketToMap () {
      const lat = this.$store.state.locationData ? this.$store.state.locationData.lat : ''
      const lng = this.$store.state.locationData ? this.$store.state.locationData.lng : ''
      const modifyTag = this.$route.params.modifyTag
      const routerName = this.$route.params.routerName
      const id = this.$route.params.id
      this.$router.push({ name: 'marketmap', params: { localName: 'addchannel', modifyTag, routerName, id, lat, lng } })
    },
    // 关闭浮层
    handleToCancleFloat (val) {
      if (val === 'customFollowFlag') {
        this.customFollowFlag = false
        this.mmFollowStaffList = []
        this.mmFollowStaffTag = []
        this.mmFollowStaffList.push({
          actorname: this.$cookies.get('actorname'),
          actorno: this.$cookies.get('actorno')
        })
        this.mmFollowStaffTag.push(this.$cookies.get('actorno'))
      } else if (val === 'customFollowFlagadd') {
        this.customFollowFlag = false
      }
      document.body.style.overflow = 'auto'
    }
  },
  beforeRouteLeave (to, from, next) {
    const postData = {
      id: this.id,
      cusName: this.cusName,
      remark: this.remark,
      mmContactsList: this.mmContactsList,
      mmFollowStaffList: this.mmFollowStaffList,
      mmFollowStaffTag: this.mmFollowStaffTag
    }
    const tourl = to.path
    const fromurl = from.path
    const endTime = new Date().getTime()
    const time = endTime - this.startTime
    post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl, time })
    if (to.name === 'marketmap' && from.name === 'addchannel') {
      localStorage.setItem('postData', JSON.stringify(postData))
      next()
    } else {
      localStorage.removeItem('postData')
      next()
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.addchannel
  position : relative
  width : 100vw
  min-height : 100vh
  overflow-x : hidden
  overflow-y : scroll
  .addchannel--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .addchannel--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--cancle
        width : 120px
        padding-left : 16px
        text-align : left
      .title--complete
        width : 120px
        padding-right : 16px
        text-align : right
      .title--text
        flex : 1
        text-align : center
    .addchannel--header--text
      box-sizing : border-box
      width : 100%
      display : flex
      background : #f7f7f7
      padding : 26.5px 16px
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
  .header-line
    height : 170px
    width : 100%
  .addchannel--info
    //margin-top : 16px
    padding-bottom :  64px
    .addchannel--info--name
      display : flex
      align-items : center
      margin : 0 16px
      padding : 16px 0
      border-bottom : 1px solid #8b8787
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      &.active
        border : 1px solid #b45858
      .item--name
        width : 150px
        line-height : 47px
      .item--icon
        width : 120px
        text-align : right
        padding-right : 16px
        line-height : 47px
        font-size: 48px
        color : #4282e1
      .item--img--icon
        text-align : center
        line-height : 48px
        font-size: 48px
        color : #4282e1
        &>>>.van-uploader__upload
          height : 47px
          background-color : #ffffff
          margin : 0
        &>>>.van-uploader__upload-icon
          color : #4282e1
          font-size: 48px
      .item--ipt
        flex : 1
        height : 32px
        padding : 16px 0 16px 16px
        border: none;
        border-radius: 8px
        outline : none
        margin : 0 16px
        &:focus
          border-color: #4282e1
          outline: none
        &:disabled
          background-color : #ffffff
          color: #000000
          opacity:1
      .item--area
        flex : 1
        padding : 0 0 16px 16px
        border: none;
        border-radius: 8px
        outline : none
        margin : 0 16px
        resize : none
        overflow: hidden;
        &::placeholder
          line-height : 130px
        &:focus
          border-color: #4282e1
          outline: none
        &:disabled
          background-color : #ffffff
          color: #000000
          opacity:1
      .item--address
        flex : 1
        margin-left : 16px
        padding : 16px
        line-height : 47px
    .addchannel--info--desc
      margin-bottom : 0
    .addchannel--info--text
      display : flex
      justify-content : space-between
      align-items : center
      padding : 16px
      background : #f7f7f7
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      .text--item
        font-size: 48px
        padding : 8px 16px 8px 24px
        color : #4282e1
    .addchannel--info--job
      margin-bottom : 0
    .addchannel--info--follow
      margin-bottom : 0
      padding : 32px 16px
    .addchannel--info--person
      display : flex
      padding : 16px 0
      margin : 0 16px
      border-bottom : 1px solid #8b8787
      .person--item
        background-color : #4282e1
        margin-right : 32px
        width : 100px
        height : 100px
        line-height : 100px
        text-align : center
        border-radius : 50%
        color : #ffffff
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
      .person--plus
        font-size : 32px
    .addchannel--info--contract
      background-color : #707e8d
      font-family: MyriadPro-Regular
      font-size: 26px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .contract--item
        display : flex
        padding : 8px 0
        .item-icon
          width : 40px
          padding : 16px
          font-size : 24px
        .item--name
          flex : 1
          padding : 16px 0 16px 16px
        .item--phone
          padding : 16px 0
          flex : 1
        .item--job
          padding : 16px 0
          flex : 1
          padding-right : 16px
          text-align : right
  .addchannel--source
    position : fixed
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow-y : scroll
    .source--title
      display : flex
      background-color : #687591
      .source--title--cancle
        width : 150px
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
      .source--title--text
        flex : 1
        padding : 16px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 38px
        font-weight: normal
        font-stretch: normal
        color: #ffffff
    .source--item
      margin : 0 32px
      padding : 48px 0
      display : flex
      justify-content : center
      align-items : center
      border-left : 1px solid #aaa5a5
      .source--item--num
        width : 40px
        height : 40px
        margin-left : -20px
        line-height : 40px
        text-align : center
        border-radius : 50%
        font-family: MyriadPro-Regular
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #333333
        background-color : #aaa5a5
        &.active
          color: #ffffff
          background-color : #4282e1
      .source--item--icon
        margin-left : 0
      .source--item--text
        flex : 1
        padding : 8px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        border-bottom : 1px solid #aaa5a5
        &.active
          color : #4282e1
      .source--title--product
        flex : 1
        padding : 8px 16px
        text-align : left
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        border-bottom : 1px solid #aaa5a5
        &.active
          color : #4282e1
        .product--desc
          margin-top : 16px
    .source--item--follow
      padding : 16px
      width : 100%
      box-sizing : border-box
      display : flex
      flex-wrap : wrap
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: normal
      font-stretch: normal
      color: #333333
      .source--item--follow__per
        width : calc(25% - 16px)
        padding : 16px 0
        text-align : center
        margin-top : 16px
        border : 1px solid #979393
        margin-right : 16px
        border-radius : 12px
        background-color : #F0F0F0
        &:nth-child(4n)
          margin-right : 0
        &.active
          color: #ffffff
          background-color :#7186d3
          border : 1px solid #979393
    .source--item--first
      border-left : none
      position : relative
      &:before
        position : absolute
        top: 70%
        left :0
        content : ""
        width : 1px
        height : 50%
        background-color : #aaa5a5
    .source--item--last
      border-left : none
      position : relative
      &:before
        position : absolute
        top: 0
        left :0
        content : ""
        width : 1px
        height : 30%
        background-color : #aaa5a5
    .source--product--first
      border-left : none
      position : relative
      &:before
        position : absolute
        top: 60%
        left :0
        content : ""
        width : 1px
        height : 50%
        background-color : #aaa5a5
</style>
